/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Noisy_Lime_Panda_ClimbInputs */

const en_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please contact support.`)
};

const id_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harap hubungi dukungan.`)
};

const ms_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sila hubungi sokongan.`)
};

const ca_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacta amb el suport.`)
};

const cs_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte prosím podporu.`)
};

const da_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt venligst support.`)
};

const de_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte kontaktiere den Support.`)
};

const et_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Võta ühendust toega.`)
};

const es_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, contacta al equipo de soporte.`)
};

const fr_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez contacter le support.`)
};

const hr_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molimo kontaktirajte podršku.`)
};

const it_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatta il supporto.`)
};

const lv_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lūdzu, sazinieties ar atbalsta dienestu.`)
};

const lt_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susisiekite su palaikymo komanda.`)
};

const hu_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kérjük, lépj kapcsolatba az ügyfélszolgálattal.`)
};

const nl_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neem contact op met de ondersteuning.`)
};

const nb_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vennligst kontakt support.`)
};

const pl_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skontaktuj się z pomocą techniczną.`)
};

const pt_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre em contato com o suporte.`)
};

const ro_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te rugăm să contactezi suportul.`)
};

const sk_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte prosím podporu.`)
};

const sl_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrnite se na podporo.`)
};

const fi_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä tukeen.`)
};

const sv_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakta supporten.`)
};

const vi_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng liên hệ với bộ phận hỗ trợ.`)
};

const tr_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen destek ekibiyle iletişime geçin.`)
};

const el_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παρακαλούμε επικοινωνήστε με την υποστήριξη.`)
};

const bg_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моля, свържете се с поддръжката.`)
};

const ru_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, обратитесь в службу поддержки.`)
};

const sr_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контактирајте подршку.`)
};

const uk_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зверніться до служби підтримки.`)
};

const ka_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გთხოვთ, დაუკავშირდით მხარდაჭერას.`)
};

const hi_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया सपोर्ट से संपर्क करें।`)
};

const th_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดติดต่อฝ่ายสนับสนุน`)
};

const ko_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지원팀에 문의해 주세요.`)
};

const zh_tw_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請聯絡支援團隊。`)
};

const ja_noisy_lime_panda_climb = /** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポートにお問い合わせください。`)
};

/** @type {(inputs: Noisy_Lime_Panda_ClimbInputs) => LocalizedString} */
const zh_noisy_lime_panda_climb = en_noisy_lime_panda_climb;

/**
* | output |
* | --- |
* | "Please contact support." |
*
* @param {Noisy_Lime_Panda_ClimbInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const noisy_lime_panda_climb = /** @type {((inputs?: Noisy_Lime_Panda_ClimbInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Noisy_Lime_Panda_ClimbInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_noisy_lime_panda_climb(inputs)
	if (locale === "ms") return ms_noisy_lime_panda_climb(inputs)
	if (locale === "ca") return ca_noisy_lime_panda_climb(inputs)
	if (locale === "cs") return cs_noisy_lime_panda_climb(inputs)
	if (locale === "da") return da_noisy_lime_panda_climb(inputs)
	if (locale === "de") return de_noisy_lime_panda_climb(inputs)
	if (locale === "et") return et_noisy_lime_panda_climb(inputs)
	if (locale === "es") return es_noisy_lime_panda_climb(inputs)
	if (locale === "fr") return fr_noisy_lime_panda_climb(inputs)
	if (locale === "hr") return hr_noisy_lime_panda_climb(inputs)
	if (locale === "it") return it_noisy_lime_panda_climb(inputs)
	if (locale === "lv") return lv_noisy_lime_panda_climb(inputs)
	if (locale === "lt") return lt_noisy_lime_panda_climb(inputs)
	if (locale === "hu") return hu_noisy_lime_panda_climb(inputs)
	if (locale === "nl") return nl_noisy_lime_panda_climb(inputs)
	if (locale === "nb") return nb_noisy_lime_panda_climb(inputs)
	if (locale === "pl") return pl_noisy_lime_panda_climb(inputs)
	if (locale === "pt") return pt_noisy_lime_panda_climb(inputs)
	if (locale === "ro") return ro_noisy_lime_panda_climb(inputs)
	if (locale === "sk") return sk_noisy_lime_panda_climb(inputs)
	if (locale === "sl") return sl_noisy_lime_panda_climb(inputs)
	if (locale === "fi") return fi_noisy_lime_panda_climb(inputs)
	if (locale === "sv") return sv_noisy_lime_panda_climb(inputs)
	if (locale === "vi") return vi_noisy_lime_panda_climb(inputs)
	if (locale === "tr") return tr_noisy_lime_panda_climb(inputs)
	if (locale === "el") return el_noisy_lime_panda_climb(inputs)
	if (locale === "bg") return bg_noisy_lime_panda_climb(inputs)
	if (locale === "ru") return ru_noisy_lime_panda_climb(inputs)
	if (locale === "sr") return sr_noisy_lime_panda_climb(inputs)
	if (locale === "uk") return uk_noisy_lime_panda_climb(inputs)
	if (locale === "ka") return ka_noisy_lime_panda_climb(inputs)
	if (locale === "hi") return hi_noisy_lime_panda_climb(inputs)
	if (locale === "th") return th_noisy_lime_panda_climb(inputs)
	if (locale === "ko") return ko_noisy_lime_panda_climb(inputs)
	if (locale === "zh") return zh_noisy_lime_panda_climb(inputs)
	if (locale === "zh-tw") return zh_tw_noisy_lime_panda_climb(inputs)
	if (locale === "ja") return ja_noisy_lime_panda_climb(inputs)
	return en_noisy_lime_panda_climb(inputs)
});